module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid10_800x677.5d5ba80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid10_800x677.jpg
// module id = /I7a
// module chunks = 0